export default function ContextProviderManager({ providers, children }) {
  return providers.reduceRight((children, Parent) => <Parent>{children}</Parent>, children);
}
